interface StockBadgeProps {
  available: number;
  threshold: number;
}

// 재고 수량 pill. PR6에서 /order와 공유될 예정이라 inventory 타입(InventoryItem 등)에 의존하지 않고
// 원시값만 받는다 — 이 파일의 유일한 상태 규칙(색 분기)이 여기 있다.
// PR3: 판정 기준을 stock(현재고)에서 available(가용 = stock − reserved, 호출부에서 렌더 시 계산해
// 넘김)로 전환 — 예약된 수량은 실제로 팔 수 없으므로 부족/품절 판정은 가용 기준이어야 정확하다.
// available<=0(품절·마이너스 포함) = red, 0<available<=threshold(부족) = amber, 그 외 = 중립 회색.
export function StockBadge({ available, threshold }: StockBadgeProps) {
  const toneClass =
    available <= 0
      ? 'bg-red-100 text-red-700'
      : available <= threshold
        ? 'bg-amber-100 text-amber-800'
        : 'bg-slate-100 text-slate-600';

  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-bold tabular-nums ${toneClass}`}
    >
      {available.toLocaleString('ko-KR')}
    </span>
  );
}
